import { render } from "./Manage.vue?vue&type=template&id=53327af9&ts=true"
import script from "./Manage.vue?vue&type=script&lang=ts"
export * from "./Manage.vue?vue&type=script&lang=ts"

import "./Manage.vue?vue&type=style&index=0&id=53327af9&lang=scss"

import exportComponent from "/home/build/jenkins/workdir/workspace/fast-build/fast-build/67161/vshow-main/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__